export default "__VITE_ASSET__CFYvEgrQ__"